<template>
  <aside class="flex h-full flex-col bg-base-100 border-r border-base-300/60">


    <nav class="flex-1 overflow-y-auto px-2 py-3 scrollbar-thin">
      <div v-for="section in sections" :key="section.title" class="mb-3">
        <p class="px-2 py-1.5 text-xs font-semibold uppercase tracking-wider text-base-content/40">
          {{ section.title }}
        </p>
        <ul class="space-y-0.5">
          <li v-for="item in section.items" :key="item.to || item.action">
            <button
              v-if="item.action === 'contact'"
              type="button"
              class="flex w-full items-center gap-2.5 rounded-lg px-2.5 py-2 text-sm transition-all text-base-content/70 hover:bg-base-200 hover:text-base-content border-l-2 border-transparent pl-2"
              @click="openContactModal"
            >
              <span v-html="item.icon" class="shrink-0 w-4 h-4 opacity-70"></span>
              <span>{{ item.label }}</span>
            </button>
            <router-link
              v-else
              :to="item.to"
              class="flex items-center gap-2.5 rounded-lg px-2.5 py-2 text-sm transition-all"
              :class="isActive(item.to)
                ? 'bg-primary/10 text-primary font-medium border-l-2 border-primary pl-2'
                : 'text-base-content/70 hover:bg-base-200 hover:text-base-content border-l-2 border-transparent pl-2'"
            >
              <span v-html="item.icon" class="shrink-0 w-4 h-4 opacity-70"></span>
              <span>{{ item.label }}</span>
              <span v-if="item.badge" class="badge badge-primary badge-xs ml-auto">{{ item.badge }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </nav>

    <div class="shrink-0 border-t border-base-300/60 p-3">
      <div class="rounded-xl bg-primary/5 border border-primary/10 p-4">
        <p class="text-sm font-semibold text-primary mb-1">Hemen Başlayın</p>
        <p class="text-xs text-base-content/60 mb-3">Ücretsiz hesap oluşturun ve tüm özelliklere erişin.</p>
        <router-link to="/users/signIn" class="btn btn-primary btn-sm w-full">
          Ücretsiz Kayıt Ol
        </router-link>
      </div>
    </div>
  </aside>
</template>

<script setup>
import { useRoute } from "vue-router";
import useContactModal from "../../compositions/useContactModal";

const route = useRoute();
const { openContactModal } = useContactModal();

const iconHome = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" /></svg>`;
const iconLogin = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75" /></svg>`;
const iconSignup = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM4 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 10.374 21c-2.331 0-4.512-.645-6.374-1.766Z" /></svg>`;
const iconTos = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" /></svg>`;
const iconPrivacy = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" /></svg>`;
const iconContact = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" /></svg>`;

const sections = [
  {
    title: 'Gezinme',
    items: [
      { to: '/', label: 'Ana Sayfa', icon: iconHome },
      { action: 'contact', label: 'İletişim', icon: iconContact },
    ],
  },
  {
    title: 'Hesap',
    items: [
      { to: '/users/login', label: 'Giriş Yap', icon: iconLogin },
      { to: '/users/signIn', label: 'Kayıt Ol', icon: iconSignup, badge: 'Ücretsiz' },
    ],
  },
  {
    title: 'Yasal',
    items: [
      { to: '/tos', label: 'Kullanım Şartları', icon: iconTos },
      { to: '/privacy', label: 'Gizlilik Politikası', icon: iconPrivacy },
      { to: '/cookie-policy', label: 'Çerez Politikası', icon: iconTos },
    ],
  },
];

const isActive = (path) => route.path === path || route.path.startsWith(path + '/');
</script>

<style scoped>
.scrollbar-thin {
  scrollbar-width: thin;
}
</style>
